
export interface Data {
  pointer: string;
  value: string;
}

export interface RegexData {
  regex: RegExp;
  value: string;
}


export interface StringHTMLBuilderService {
  setDynamicData(data: Array<Data>): void;
  getStringHTML(): string;
}

export default class StringHTMLBuilder implements StringHTMLBuilderService {
  private stringHTML: string;

  public constructor(private template: string) {
    this.stringHTML = template;
  }

  public setDynamicData(data: Array<Data>) {
    data.forEach((item) => {
      if (this.stringHTML.includes(item.pointer)) {
        const re = new RegExp(`[$]${item.pointer}`, 'gi');
        this.stringHTML = this.stringHTML.replace(re, item.value);
      }
    });
  }

  public getStringHTML() {
    return this.stringHTML;
  }

  public setDataByRegex(data: Array<RegexData>) {
    data.forEach((item) => {
      this.stringHTML = this.stringHTML.replace(item.regex, item.value);
    });
  }

  public getScriptFromContent() {
    const scriptContent = this.stringHTML.match(/<script>(.*?)<\/script>/s);
    return scriptContent?.[1] || '';
  }
}
